import React from 'react'
import {Modal} from 'react-bootstrap'
import SUCCESSFUL from 'assets/images/svg/Group 7156.svg'
import {Link} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import {json} from 'helpers/data';

const PaymentApproved = ({show, data, onHide, ...props}) => {
    const {t} = useTranslation("browse-apps");

    function downloadApp() {
        const link = document.createElement("a");
        link.download = json(data?.title);
        link.target = "_blank";
        link.href = data?.url;
        link.click();
    }

    return (
        <div className=''>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={onHide}
                className='all-modal fawry paymentApproved'
            >
                <Modal.Body>
                    <div className='header'>

                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <img className='fawryIcon' src={SUCCESSFUL} alt="fawry"/>
                            <h1 className='title'>{t("paymentDetails.paymentMessage.paymentSuccess")}</h1>
                            <p className='order-info'>{t("paymentDetails.paymentMessage.paymentSuccessInfo")} Dexef Cashier</p>
                        </div>


                        <div className='col-12'>
                            {
                                data?.isAddOn &&
                                <Link to={`/my-apps/${data?.versionSubscriptionId}/addons`}
                                      className='btn-White'>Manage your addons</Link>
                            }

                            <button hidden={data?.isAddOn} className='btn-blue'
                                    onClick={downloadApp}>{t("paymentDetails.paymentMessage.downloadNow")}</button>
                            {
                                !data?.isAddOn &&
                                <Link to="/my-products"
                                      className='btn-White'>{t("paymentDetails.paymentMessage.manage")}</Link>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PaymentApproved